import { useEffect, useState } from 'react';
import { clearToken, decodeToken, getToken, isExpired } from './tokenStore';

export interface SessionUser {
  userId: string;
  username?: string;
  displayName?: string;
}

export function useUser(): { user: SessionUser | null; signOut: () => void } {
  const [user, setUser] = useState<SessionUser | null>(() => {
    const tok = getToken();
    if (!tok || isExpired(tok)) return null;
    const d = decodeToken(tok);
    if (!d) return null;
    return { userId: d.userId, username: d.username, displayName: d.displayName };
  });

  // Listen for cross-tab sign-in / sign-out via the storage event so the UI
  // stays consistent if the user signs in elsewhere.
  useEffect(() => {
    function onStorage() {
      const tok = getToken();
      if (!tok || isExpired(tok)) return setUser(null);
      const d = decodeToken(tok);
      setUser(d ? { userId: d.userId, username: d.username, displayName: d.displayName } : null);
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  function signOut() {
    clearToken();
    setUser(null);
  }

  return { user, signOut };
}
